import { render } from "./OTPForm.vue?vue&type=template&id=54fa7ca9&scoped=true"
import script from "./OTPForm.vue?vue&type=script&lang=js"
export * from "./OTPForm.vue?vue&type=script&lang=js"

import "./OTPForm.vue?vue&type=style&index=0&id=54fa7ca9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fa7ca9"]])

export default __exports__